import OrderItemTotal from "@/model/OrderItemTotal";
import { LocalTime } from "@js-joda/core";
import { ResourceType } from "@/model/enum/ResourceType";
export function createOrderItem() {
    return {
        productId: 0,
        dateFrom: new Date(),
        dateTo: new Date(),
        itemTotal: new OrderItemTotal(),
        reservations: {},
        resources: {}
    };
}
export function getAttributeReservations(orderItem) {
    return Object.entries(orderItem.reservations)
        .filter(([key]) => {
        const resource = orderItem.resources[Number(key)];
        return resource?.resourceType === ResourceType.ATTRIBUTE;
    })
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}
export function getResourceReservations(orderItem) {
    return Object.entries(orderItem.reservations)
        .filter(([key]) => {
        const resource = orderItem.resources[Number(key)];
        return resource?.resourceType === ResourceType.RESOURCE;
    })
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}
export function assignOrderItem(target, other) {
    Object.assign(target, other);
    target.dateFrom = new Date(other.dateFrom);
    target.dateTo = new Date(other.dateTo);
    if (other.startTime) {
        target.startTime = LocalTime.parse(other.startTime.toString());
    }
    if (other.endTime) {
        target.endTime = LocalTime.parse(other.endTime.toString());
    }
    target.itemTotal = new OrderItemTotal();
    target.itemTotal.assign(other.itemTotal);
}
